export default function HomeHeroOrb() {
  return (
    <div className="home-hero-orb-stage" aria-hidden="true">
      <div className="home-hero-orb-glow home-hero-orb-glow--green" />
      <div className="home-hero-orb-glow home-hero-orb-glow--orange" />
      <div className="home-hero-orb-glow home-hero-orb-glow--center" />

      <svg viewBox="0 0 420 420" className="home-hero-orb-svg" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="heroRingOrange" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#F79839" stopOpacity="0.35" />
            <stop offset="35%" stopColor="#F79839" stopOpacity="0.95" />
            <stop offset="65%" stopColor="#ffb86a" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#F79839" stopOpacity="0.45" />
          </linearGradient>
          <linearGradient id="heroRingGreen" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#18A67F" stopOpacity="0.4" />
            <stop offset="40%" stopColor="#18A67F" stopOpacity="0.92" />
            <stop offset="70%" stopColor="#5fd4b0" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#18A67F" stopOpacity="0.35" />
          </linearGradient>
          <linearGradient id="heroRingBlend" x1="0%" y1="50%" x2="100%" y2="50%">
            <stop offset="0%" stopColor="#18A67F" stopOpacity="0.75" />
            <stop offset="50%" stopColor="#F79839" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#18A67F" stopOpacity="0.75" />
          </linearGradient>
          <radialGradient id="heroSphereCore" cx="36%" cy="32%" r="68%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="1" />
            <stop offset="18%" stopColor="#fff8ef" stopOpacity="0.98" />
            <stop offset="42%" stopColor="#F79839" stopOpacity="0.92" />
            <stop offset="68%" stopColor="#e8872a" stopOpacity="0.78" />
            <stop offset="88%" stopColor="#18A67F" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#128f6c" stopOpacity="0.42" />
          </radialGradient>
          <radialGradient id="heroSphereDepth" cx="62%" cy="68%" r="55%">
            <stop offset="0%" stopColor="#18A67F" stopOpacity="0.28" />
            <stop offset="55%" stopColor="#0f6b52" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#0f172a" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="heroSphereHalo" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#F79839" stopOpacity="0.32" />
            <stop offset="45%" stopColor="#18A67F" stopOpacity="0.14" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="heroSphereRing" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#18A67F" stopOpacity="0.9" />
            <stop offset="50%" stopColor="#F79839" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#18A67F" stopOpacity="0.9" />
          </linearGradient>
          <filter id="heroSphereGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="6" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <circle cx="210" cy="210" r="128" fill="url(#heroSphereHalo)" opacity="0.65" className="home-hero-orb-halo" />

        <g className="home-hero-orb-spin home-hero-orb-spin--slow">
          <ellipse cx="210" cy="210" rx="168" ry="62" fill="none" stroke="url(#heroRingBlend)" strokeWidth="1.45" strokeLinecap="round" />
          <ellipse cx="210" cy="210" rx="168" ry="62" fill="none" stroke="url(#heroRingBlend)" strokeWidth="1.45" strokeLinecap="round" transform="rotate(120 210 210)" />
          <ellipse cx="210" cy="210" rx="168" ry="62" fill="none" stroke="url(#heroRingBlend)" strokeWidth="1.45" strokeLinecap="round" transform="rotate(240 210 210)" />
        </g>

        <circle cx="210" cy="210" r="58" fill="none" stroke="url(#heroSphereRing)" strokeWidth="1.5" opacity="0.8" className="home-hero-orb-core-ring" />
        <circle cx="210" cy="210" r="50" fill="url(#heroSphereCore)" filter="url(#heroSphereGlow)" className="home-hero-orb-core" />
        <circle cx="210" cy="210" r="50" fill="url(#heroSphereDepth)" className="home-hero-orb-core" />
        <ellipse cx="200" cy="196" rx="12" ry="8" fill="rgba(255,255,255,0.52)" />
        <circle cx="204" cy="192" r="3.5" fill="rgba(255,255,255,0.9)" />
      </svg>
    </div>
  );
}
